import { forwardRef, memo, MutableRefObject } from "react";
import { default as MaskedInput, MaskedInputProps } from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { useMergedRef } from "../../../../../utils";

const autoCorrectedDatePipe = createAutoCorrectedDatePipe("mm/dd/yyyy");

type Created = Omit<MaskedInputProps, "mask"> & { additionalRef?: MutableRefObject<MaskedInput | undefined> };

const DateFieldMask = memo<Created>(forwardRef<MaskedInput, Created>(({ additionalRef, ...props }, ref) =>
  <MaskedInput
    ref={useMergedRef(ref, additionalRef)}
    type="text"
    pipe={autoCorrectedDatePipe}
    mask={[ /\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/ ]}
    {...props}
  />,
));

export default DateFieldMask;
